<ion-grid
  [ngClass]="(navService.isActiveChildNavRightPaneViewDisplayed)?'child-nav-active':'child-nav-inactive'"
>
  <ion-row>
    <ion-col class="notification-left-pane go-app-home-nav-pane" no-padding>
      <notification-list [from]="'homePage'"></notification-list>
    </ion-col>
    <ion-col class="notification-right-pane go-app-home-nav-pane">
      <ion-nav #notificationrightpane></ion-nav>
    </ion-col>
  </ion-row>
</ion-grid>
